module.exports = __webpack_public_path__ + "img/asset1.11f67655.jpg";